export const CENTER_LEADER_FIELD_NAMES = {
  SECONDARY_LEADER: 'employeeEnrollment2LeaderId',
  ADMINISTRATIVE_LEADER: 'employeeEnrollmentAdministrativeId',
}
